import React, { FC, useEffect, useState, useRef } from 'react'
import ProtocolsEmpty from './ProtocolsEmpty'
import styled from 'styled-components'
import { theme, Image, Spinner } from 'ui'
import { Add, CalendarToday, PersonOutline } from '@material-ui/icons'
import useStore, { budgetStore } from 'store'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import { ValidatedPopulationInput } from '../PopulationManagement/ValidatedInput'
import DateInputWithCalendar from '../PopulationManagement/CalendarInput' 

import { Table, TableBody, TableCell, TableRow, IconButton, RadioGroup, Radio, Tooltip } from '@material-ui/core'
import MekomeTablePagination from 'components/MekomeTablePagination'

import { 
  SearchInput,
  StyledInputContainer,
  StyledInput,
  StyledLabel,
  StyledRequired,
  StyledSelect,
  Header,
  HeaderButtonGroup,
  HeaderTitleContainer,
  HeaderMainTitle,
  HeaderSecondTitle,
  HeaderButton,
  HeaderImageIcon,

  StatsBarContainer,
  StatsCard,
  StatsCardContainer,
  StatsTitleContainer,
  StatsTitle,
  StatsCount,
  StatsImageIcon,

  SearchBar,
  SearchAndFilterWrapper,
  SearchBarContainer,
  FilterButton,
  FilterImageIcon,

  FilterContainer,
  FilterTitle,
  FilterSectionLabel,
  FilterRadioFormControlLabel,
  FilterRadioSelectedTitle,

  TableBar,
  TableContainerStyled,
  TableHeadStyled,
  TableCellTitle,
  TableCellCategory,
  TableCellCategoryLabel,
  TableCellStatus,
  TableCelllOnline,
  TableCellDescription1,
  TableCellDescription2,
  TableCellStyled,
  TableCellCentered,
  HeadCell,
  HeadCellCentered,

  FilterRadioContainer,
  FilterInputContainer,
  FilterTitleContainer,
  FilterField,
  DateRangeRow,
  FilterActionsRow,
  FilterButtonApply,
  StatusItemImageIcon
} from './Protocols.styles'

import { getProtocolPermissions } from './permissions'
import { PROTOCOL_PALETTE } from './palette'
import { cleanImportedText } from './textUtils'
import { STATUS_MAP, getIconByStatus } from './statusMap'
import CategoryModal from './CategoryModal'
import SetMainManagerModal from './SetMainManagerModal'
import ProtocolModal from './ProtocolModal'
import ProtocolViewModal from './ProtocolViewModal'
import ArchiveList from './ArchiveList'
import RemoveProtocolModal from './RemoveProtocolModal'
import ArchiveProtocolModal from './ArchiveProtocolModal'
import ProtocolEditModal from './ProtocolEditModal'
import ProtocolEditStatusModal from './ProtocolEditStatusModal'
import ProtocolsSearchBar from './ProtocolsSearchBar'
import ProtocolsFilterPanel, { ProtocolsFilters, filtersToListQuery } from './ProtocolsFilterPanel'
import AyeIcon from 'assets/icons/ims/Aye.svg'
import SettingsIcon from 'assets/icons/ims/Settings.svg'
import BoxIcon from 'assets/icons/ims/Box.svg'
import CloseIcon from 'assets/icons/ims/Close3.svg'
import ClockIcon from 'assets/icons/ims/Clock.svg'
import EditIcon from 'assets/icons/ims/Edit.svg'
import OkIcon from 'assets/icons/ims/Ok.svg'
import DocIcon from 'assets/icons/ims/Doc.svg'
import FileIcon from 'assets/icons/ims/File.svg'
import User4Icon from 'assets/icons/ims/User4.svg'
import DeleteIcon from 'assets/icons/ims/Delete.svg'
import ZeroFilter from 'assets/icons/ims/ZeroFilter.svg'
import AyeIcon2 from 'assets/icons/protocols/icon11.svg'
import { useHistory } from 'react-router'
import { Path } from 'core/Routes'


const Wrap = styled.div`
  background-color:${theme.color.dialogBackground};
  @media (max-width: 768px) {
    background: rgba(0,0,0,0.05);
    padding: 1rem;
  }
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1rem;
  /* Scroll the page instead of clipping it: at browser zoom levels above 100%
     the header, stats and advanced-filter blocks no longer fit the viewport,
     and 'overflow: hidden' used to cut off the bottom of the filter panel. */
  overflow-y: auto;
  overflow-x: hidden;
  min-height: 0;
`
const LoadingText = styled.div`
  margin-top: 8px;
  color: #6A7282;
  font-family: Rubik;
  font-size: 14px;
  line-height: 20px;
`
const StyledIconButton = styled(IconButton)`
  padding: 8px;
`
const Protocols: FC = () => {
  const { t } = useTranslation(['protocols', 'budget'])
  const { members, orgs, uiStore, memberStore, user, modulesStore, protocolsStore } = useStore()
  
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [search, setSearch] = useState('')

  const [filterActive, setFilterActive] = useState(false)
  const [filterMode, setFilterMode] = useState('search_by_phrase')
  
  const [filterCategoryVal, setFilterCategoryVal] = useState('')
  const [filterPhraseVal, setFilterPhraseVal] = useState('')
  const [filterFromDate, setFilterFromDate] = useState<Date | null>(null)
  const [filterToDate, setFilterToDate] = useState<Date | null>(null)

  const [filterByStatus, setFilterByStatus] = useState<number>(0)
  const [viewProtocolId, setViewProtocolId] = useState<number | null>(null)
  const [openCategoryModal, setOpenCategoryModal] = useState(false)
  const [openMainManagerModal, setOpenMainManagerModal] = useState(false)
  const [openProtocolModal, setOpenProtocolModal] = useState(false)
  const [showArchive, setShowArchive] = useState(false)
  const [deleteProtocolId, setDeleteProtocolId] = useState<number | null>(null)
  const [deleteProtocolTitle, setDeleteProtocolTitle] = useState('')
  const [archiveProtocolId, setArchiveProtocolId] = useState<number | null>(null)
  const [archiveProtocolTitle, setArchiveProtocolTitle] = useState('')
  const [editProtocolId, setEditProtocolId] = useState<number | null>(null)
  const [statusProtocolId, setStatusProtocolId] = useState<number | null>(null)
  
  const h = useHistory()

  const perms = getProtocolPermissions(protocolsStore.userPermissions)

  // The advanced-search panel's values; creatorName is passed in because the
  // list requests use the debounced copy while the panel shows the live one.
  const currentFilters = (creatorName: string): ProtocolsFilters => ({
    mode: filterMode,
    fromDate: filterFromDate,
    toDate: filterToDate,
    status: filterByStatus,
    categoryId: filterCategoryVal,
    creatorName,
  })

  const [debouncedSearch, setDebouncedSearch] = useState('')
  const [debouncedPhrase, setDebouncedPhrase] = useState('')
  const didInitialLoad = useRef(false)

  // Debounce the free-text filters so typing fires one request per pause,
  // not one per keystroke.
  useEffect(() => {
    const id = setTimeout(() => setDebouncedSearch(search), 350)
    return () => clearTimeout(id)
  }, [search])
  useEffect(() => {
    const id = setTimeout(() => setDebouncedPhrase(filterPhraseVal), 350)
    return () => clearTimeout(id)
  }, [filterPhraseVal])

  const reloadProtocols = () => {
    protocolsStore.loadProtocols({
      pageNumber: page + 1,
      pageSize: rowsPerPage,
      ...filtersToListQuery(currentFilters(debouncedPhrase), debouncedSearch, { includeStatus: true }),
    })
    protocolsStore.loadProtocolCounts()
  }

  useEffect(() => {
    if (!modulesStore.showProtocolsFeature()) {
      h.push(Path.MESSAGES)
      return false
    }

    protocolsStore.init(orgs.currentOrgId)
  }, [modulesStore.changedOrg])

  const loadProtocolData = () => {
    protocolsStore.loadUserList()
    protocolsStore.loadProtocols({
      pageNumber: page + 1,
      pageSize: rowsPerPage,
      ...filtersToListQuery(currentFilters(filterPhraseVal), search, { includeStatus: true }),
    })

    protocolsStore.loadProtocolCounts()

    // Everyone gets the category names, which is what the filter offers: that
    // endpoint returns the categories the caller can see, whatever their role.
    // api/categories below is a manager-only endpoint and 403s for anyone else,
    // so it stays where it is - it carries the members and colours that only
    // the management screens need.
    protocolsStore.loadCategoryNames()

    if (perms.isAdmin) {
      protocolsStore.loadCategories(orgs.currentOrgId)
    }
  }

  useEffect(() => {
    if (protocolsStore.baseUrl && protocolsStore.authToken) {
      protocolsStore.loadTermsOfUse().then(() => {
        protocolsStore.loadUserPermissions().then(res => {
          loadProtocolData()
        })
      })
    }
  }, [
    //protocolsStore.baseUrl,
    protocolsStore.authToken
  ])

  useEffect(() => {
    // The auth/init effect already runs the initial load (list + counts + user
    // list + categories); skip this effect's first run so the mount doesn't
    // fetch twice. Later filter/paging changes only reload the list + counts —
    // the user list and categories don't depend on the filters.
    if (!didInitialLoad.current) { didInitialLoad.current = true; return }
    if (protocolsStore.baseUrl && protocolsStore.authToken && !showArchive) {
      reloadProtocols()
    }
  }, [
    page,
    rowsPerPage,
    debouncedSearch,
    filterByStatus,
    filterCategoryVal,
    debouncedPhrase,
    filterMode,
    filterFromDate,
    filterToDate,
    showArchive,
  ])

  const handleStatusCardClick = (status: number) => {
    setPage(0)
    setFilterByStatus(status) 
  }

  const getCategoryById = (categoryId: number): { color: string; bgColor: string } => {
    const categoryColors = ['#64748B', '#EC4899', '#06B6D4', '#EF4444', '#F59E0B', '#8B5CF6', '#10B981', '#3B82F6']
    const categoryBgColors = ['#F1F5F9', '#FDF2F8', '#ECFEFF', '#FEF2F2', '#FFFBEB', '#F5F3FF', '#ECFDF5', '#EFF6FF']
    const category = protocolsStore.categories.find(c => c.id === categoryId)
    const index = category ? category.colorId % categoryColors.length : 0
    return { color: categoryColors[index], bgColor: categoryBgColors[index] }
  }

  return (
    <Wrap>
        <CategoryModal open={openCategoryModal} onCloseModal={() => setOpenCategoryModal(false)}/>
        <SetMainManagerModal open={openMainManagerModal} onClose={() => setOpenMainManagerModal(false)}/>
        <ProtocolModal
          open={openProtocolModal}
          onCloseModal={() => { setOpenProtocolModal(false); reloadProtocols() }}
        />
        <RemoveProtocolModal
          open={deleteProtocolId !== null}
          closeModal={() => setDeleteProtocolId(null)}
          protocolId={deleteProtocolId}
          protocolTitle={deleteProtocolTitle}
          onDeleted={() => reloadProtocols()}
        />
        <ArchiveProtocolModal
          open={archiveProtocolId !== null}
          closeModal={() => setArchiveProtocolId(null)}
          protocolId={archiveProtocolId}
          protocolTitle={archiveProtocolTitle}
          onArchived={() => reloadProtocols()}
        />
        <ProtocolEditModal
          open={editProtocolId !== null}
          protocolId={editProtocolId}
          onClose={() => { setEditProtocolId(null); reloadProtocols() }}
        />
        <ProtocolEditStatusModal
          open={statusProtocolId !== null}
          protocolId={statusProtocolId}
          onClose={() => { setStatusProtocolId(null); reloadProtocols() }}
        />
        <ProtocolViewModal
          open={viewProtocolId !== null}
          protocolId={viewProtocolId}
          onClose={() => { setViewProtocolId(null); reloadProtocols() }}
        />
        {showArchive ? <ArchiveList onBack={() => {
          setPage(0)
          setShowArchive(false)
          }} /> : <>
        <Header>
             <HeaderTitleContainer>
                <HeaderMainTitle>{t`page_title`}</HeaderMainTitle>
                <HeaderSecondTitle>{t`page_subtitle`}</HeaderSecondTitle>
            </HeaderTitleContainer>
            <HeaderButtonGroup>
              {!protocolsStore.permissionsLoaded ? null : <>
               {perms.canManageMainManagers && (
                 <HeaderButton
                    color={'#0F172A'}
                    bg={'#F1F5F9'}
                    bcolor={'#E2E8F0'}
                    onClick={() => setOpenMainManagerModal(true)}
                    startIcon={<HeaderImageIcon src={User4Icon} />}
                  >
                      {t`set_main_manager`}
                  </HeaderButton>
               )}
                <HeaderButton
                  color={PROTOCOL_PALETTE.button.archive.text}
                  bg={PROTOCOL_PALETTE.button.archive.bg}
                  bcolor={PROTOCOL_PALETTE.button.archive.border}
                  onClick={() => setShowArchive(!showArchive)}
                  startIcon={<HeaderImageIcon src={BoxIcon} />}
                >{t`archive`}
                </HeaderButton>
                {(perms.isAdmin || perms.isCategoryManager) && (
                  <HeaderButton
                    color={PROTOCOL_PALETTE.button.manageCategories.text}
                    bg={PROTOCOL_PALETTE.button.manageCategories.bg}
                    bcolor={PROTOCOL_PALETTE.button.manageCategories.border}
                    onClick={() => setOpenCategoryModal(true)}
                    startIcon={<HeaderImageIcon src={SettingsIcon} />}
                  >
                      {t`manage_categories`}
                  </HeaderButton>
                )}
                {perms.canCreateProtocol && (
                <HeaderButton
                  color={PROTOCOL_PALETTE.button.newProtocol.text}
                  bg={PROTOCOL_PALETTE.button.newProtocol.bg}
                  bcolor={PROTOCOL_PALETTE.button.newProtocol.border}
                  onClick={() => setOpenProtocolModal(true)}
                  startIcon={<Add/>}
                >{t`new_protocol`}</HeaderButton>)}
              </>}
            </HeaderButtonGroup>
        </Header>

        <StatsBarContainer>
            {[
                { title: t`stat_rejected`, status: 4, count: protocolsStore.protocolCounts.rejectedCount, ...PROTOCOL_PALETTE.status.rejected, icon: CloseIcon },
                { title: t`stat_drafts`, status: 1, count: protocolsStore.protocolCounts.draftCount, ...PROTOCOL_PALETTE.status.draft, icon: EditIcon },
                { title: t`stat_pending`, status: 2, count: protocolsStore.protocolCounts.pendingApprovalCount, ...PROTOCOL_PALETTE.status.pending, icon: ClockIcon },
                { title: t`stat_approved`, status: 3, count: protocolsStore.protocolCounts.approvedCount, ...PROTOCOL_PALETTE.status.approved, icon: OkIcon },
                { title: t`stat_total`, status: 0, count: protocolsStore.protocolCounts.totalCount, ...PROTOCOL_PALETTE.status.total, icon: DocIcon },
            ].map((item) => (
              <StatsCard key={item.status} border={filterByStatus === item.status ? item.selectedBorder : item.border}  selected={filterByStatus === item.status} onClick={() => handleStatusCardClick(item.status)}>
                <StatsCardContainer>
                    <StatsTitleContainer>
                        <StatsTitle>{item.title}</StatsTitle>
                        <StatsCount color={item.countColor}>{item.count}</StatsCount>
                    </StatsTitleContainer>
                    <StatsImageIcon src={item.icon} />
                </StatsCardContainer>
              </StatsCard>
            ))}
        </StatsBarContainer>

        <SearchAndFilterWrapper>
        <ProtocolsSearchBar
          filterActive={filterActive}
          onFilterToggle={() => setFilterActive(!filterActive)}
          onSearch={val => { setPage(0); setSearch(val) }}
        />

        {filterActive && (
            <ProtocolsFilterPanel
              value={currentFilters(filterPhraseVal)}
              searchText={search}
              onChange={patch => {
                setPage(0)
                if (patch.mode !== undefined) setFilterMode(patch.mode)
                if (patch.fromDate !== undefined) setFilterFromDate(patch.fromDate)
                if (patch.toDate !== undefined) setFilterToDate(patch.toDate)
                if (patch.status !== undefined) setFilterByStatus(patch.status)
                if (patch.categoryId !== undefined) setFilterCategoryVal(patch.categoryId)
                if (patch.creatorName !== undefined) setFilterPhraseVal(patch.creatorName)
              }}
              onReset={() => {
                setPage(0)
                setFilterByStatus(0)
                setFilterCategoryVal('')
                setFilterPhraseVal('')
                setFilterFromDate(null)
                setFilterToDate(null)
                setFilterMode('search_by_phrase')
              }}
            />
        )}
        </SearchAndFilterWrapper>

        <TableBar>
            <TableContainerStyled>
                <Table stickyHeader>
                    <TableHeadStyled>
                        <TableRow>
                            <HeadCell></HeadCell>
                            <HeadCell>{t`col_title`}</HeadCell>
                            <HeadCellCentered>{t`col_category`}</HeadCellCentered>
                            <HeadCell>{t`col_date`}</HeadCell>
                            <HeadCell>{t`col_author`}</HeadCell>
                            {/* Participants column hidden for now - the count is not yet meaningful. */}
                            {/* <HeadCellCentered>{t`col_participants`}</HeadCellCentered> */}
                            <HeadCellCentered>{t`col_status`}</HeadCellCentered>
                            <HeadCellCentered>{t`col_files`}</HeadCellCentered>
                            <HeadCellCentered>{t`col_views`}</HeadCellCentered>
                            <HeadCell>{t`col_actions`}</HeadCell>
                        </TableRow>
                    </TableHeadStyled>
                    <TableBody>
                        {/* Permissions come first, then the list. Until both have
                            answered the table says what it is waiting for - it used
                            to show "no protocols found" for the whole wait, which
                            read as an empty system. */}
                        {!protocolsStore.permissionsLoaded && (
                            <TableRow>
                              <TableCell colSpan={9} align="center">
                                <Spinner />
                                <LoadingText>{t`loading_permissions`}</LoadingText>
                              </TableCell>
                            </TableRow>
                          )}

                          {protocolsStore.permissionsLoaded &&
                            (protocolsStore.loadingProtocols || !protocolsStore.protocolsLoaded) && (
                            <TableRow>
                              <TableCell colSpan={9} align="center">
                                <Spinner />
                                <LoadingText>{t`loading_protocols`}</LoadingText>
                              </TableCell>
                            </TableRow>
                          )}

                          {protocolsStore.permissionsLoaded &&
                            protocolsStore.protocolsLoaded &&
                            !protocolsStore.loadingProtocols &&
                            protocolsStore.protocols.length === 0 && (
                            <TableRow>
                              <TableCell colSpan={9} align="center">
                                <ProtocolsEmpty title={t`list_empty`} />
                              </TableCell>
                            </TableRow>
                          )}

                          {!protocolsStore.loadingProtocols && protocolsStore.protocolsLoaded &&
                            protocolsStore.protocols.map(protocol => {
                              const status = STATUS_MAP[protocol.protocolStatusId] || { titleKey: String(protocol.protocolStatusId), color: '#4C5564', bg: '#F1F5F9' }
                              const dateStr = protocol.protocolDate ? new Date(protocol.protocolDate).toLocaleDateString('he-IL') : ''
                              const { color, bgColor } = getCategoryById(protocol.categoryId)

                              return (
                              <TableRow key={protocol.id}>
                                <TableCellStyled>{!protocol.isRead && <TableCelllOnline/>}</TableCellStyled>
                                <TableCellStyled>
                                    <TableCellDescription1
                                        color={!protocol.isRead ? '#1C398E' : '#101828'}
                                        title={cleanImportedText(protocol.title)}
                                    >
                                        {cleanImportedText(protocol.title)}
                                    </TableCellDescription1>
                                    <TableCellDescription2 title={cleanImportedText(protocol.topics)}>
                                        {cleanImportedText(protocol.topics)}
                                    </TableCellDescription2>
                                </TableCellStyled>
                                <TableCellCentered><TableCellCategory color={color} bg={bgColor}><TableCellCategoryLabel title={cleanImportedText(protocol.categoryName)}>{cleanImportedText(protocol.categoryName)}</TableCellCategoryLabel></TableCellCategory></TableCellCentered>
                                <TableCellStyled><TableCellTitle>{dateStr}</TableCellTitle></TableCellStyled>
                                <TableCellStyled><TableCellTitle>{protocol.creatorName}</TableCellTitle></TableCellStyled>
                                {/* Participants column hidden for now - see the header above. */}
                                {/* <TableCellCentered><TableCellTitle><HeaderImageIcon src={User4Icon}/> {protocol.participantsCount}</TableCellTitle></TableCellCentered> */}
                                <TableCellCentered>
                                  {protocol.protocolStatusId === 4 && protocol.rejectReason ? (
                                    <Tooltip arrow title={`${t`reject_reason_inline`} ${protocol.rejectReason}`}>
                                      <TableCellStatus color={status.color} bg={status.bg}><StatusItemImageIcon src={getIconByStatus(protocol.protocolStatusId)}/> {t(status.titleKey)}</TableCellStatus>
                                    </Tooltip>
                                  ) : (
                                    <TableCellStatus color={status.color} bg={status.bg}><StatusItemImageIcon src={getIconByStatus(protocol.protocolStatusId)}/> {t(status.titleKey)}</TableCellStatus>
                                  )}
                                </TableCellCentered>
                                <TableCellCentered><TableCellTitle>{protocol.filesCount > 0 && <><HeaderImageIcon src={FileIcon}/> {protocol.filesCount}</>}</TableCellTitle></TableCellCentered>
                                <TableCellCentered><TableCellTitle>{protocol.viewsCount > 0 && <><HeaderImageIcon src={AyeIcon2}/> {protocol.viewsCount}</>}</TableCellTitle></TableCellCentered> 
                                <TableCellStyled>
                                  <Tooltip arrow title={t`action_view`}>
                                    <StyledIconButton onClick={() => { setViewProtocolId(protocol.id); protocolsStore.markProtocolAsRead(protocol.id); protocolsStore.loadProtocolForView(protocol.id) }}><HeaderImageIcon src={AyeIcon}/></StyledIconButton>
                                  </Tooltip>
                                  {/* Shown independently - a user can hold both roles at once (e.g. Category
                                      Manager + Approver): edit (Draft/Pending, UpdateProtocol) and
                                      approve/reject (ApproveOrRejectProtocol) are separate actions/endpoints. */}
                                  {protocol.isEditAll && (
                                    <Tooltip arrow title={t`action_edit`}>
                                      <StyledIconButton onClick={() => { setEditProtocolId(protocol.id); protocolsStore.loadProtocolForEdit(protocol.id) }}><HeaderImageIcon src={EditIcon}/></StyledIconButton>
                                    </Tooltip>
                                  )}
                                  {protocol.isEditStatus && (
                                    <Tooltip arrow title={t`action_approve`}>
                                      <StyledIconButton onClick={() => { setStatusProtocolId(protocol.id); protocolsStore.loadProtocolForEditStatus(protocol.id) }}><HeaderImageIcon src={OkIcon}/></StyledIconButton>
                                    </Tooltip>
                                  )}
                                  {protocol.isDelete && (
                                    <Tooltip arrow title={t`action_delete`}>
                                      <StyledIconButton onClick={() => { setDeleteProtocolId(protocol.id); setDeleteProtocolTitle(cleanImportedText(protocol.title)) }}><HeaderImageIcon src={DeleteIcon}/></StyledIconButton>
                                    </Tooltip>
                                  )}
                                  {protocol.isArchive && (
                                    <Tooltip arrow title={t`action_archive`}>
                                      <StyledIconButton onClick={() => { setArchiveProtocolId(protocol.id); setArchiveProtocolTitle(cleanImportedText(protocol.title)) }}><HeaderImageIcon src={BoxIcon}/></StyledIconButton>
                                    </Tooltip>
                                  )}
                                </TableCellStyled>
                              </TableRow>
                            )})}
                      </TableBody>
                    </Table>
            </TableContainerStyled>
            <MekomeTablePagination
                component="div"
                count={protocolsStore.protocolsTotalCount}
                page={page}
                onPageChange={(_, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={e => {
                    setRowsPerPage(parseInt(e.target.value, 10))
                    setPage(0)
                }}
                rowsPerPageOptions={[20]}
            />
        </TableBar>
        </>}
    </Wrap>
  )
}


export default observer(Protocols)

